import type { ShareThisConfig } from '@/types/sharethis'
import type { Coupon, Price } from '@/types/entities'

export const getDiscount = (price: Price, coupon?: Coupon | null): number => {
  let discount = 0

  if (coupon?.amount_off) {
    discount = Number((coupon.amount_off / 100).toFixed(2))
  } else if (coupon?.percent_off) {
    discount = Number(((price.price * (+coupon.percent_off / 100)) / 100).toFixed(2))
  }

  return discount
}

export const getDiscountedPrice = (price: Price, coupon: Coupon): number => {
  return price.price - getDiscount(price, coupon)
}

export const getShareThisConfig = (title: string, description: string, url: string, image: string): ShareThisConfig => {
  return {
    analytics: {
      enabled: true,
    },
    'inline-share-buttons': {
      alignment: 'center',
      background_color: 'B581A3',
      color: 'social',
      enabled: true,
      font_size: 12,
      has_spacing: true,
      id: 'sharing-buttons',
      is_ssb: false,
      labels: 'none',
      language: 'en',
      min_count: 10,
      networks: ['facebook', 'twitter', 'pinterest', 'messenger', 'linkedin', 'reddit', 'whatsapp', 'sms', 'copy'],
      num_networks: 8,
      num_ssb_networks: 6,
      padding: 10,
      radius: 5,
      show_total: false,
      size: 32,
      size_label: 'small',
      spacing: 8,
      text_color: '#fff',
      use_native_counts: true,

      title,
      description,
      url,
      image,
    },
  }
}
